import { createSelector } from "reselect";
import { LoginState } from "../login/reducer";
import { removeOktaCredentials } from "../route/LocalStorage";
import { SessionState } from "../session/reducer";
import { State } from "../state";

const getUserState = (state: State) => state.user;
const getSessionState = (state: State) => state.session;

export const isUserAuthenticated = createSelector(
  getUserState,
  getSessionState,
  (loggedInState: LoginState, sessionState: SessionState) => {
    const { user } = loggedInState;
    const currentTime = new Date().getTime();
    const issuedAt = parseInt(user.credentials.issuedAt || "0", 10);
    const apiDuration = parseInt(user.credentials.expiresIn || "0", 10) * 1000;
    const lastUsed = parseInt(user.credentials.lastUsed || "0", 10);

    if (
      !(
        !sessionState.authError &&
        user.isAuthenticated &&
        (issuedAt + apiDuration > currentTime ||
          lastUsed + apiDuration > currentTime)
      )
    ) {
      removeOktaCredentials();
    }
    return (
      !sessionState.authError &&
      user.isAuthenticated &&
      (issuedAt + apiDuration > currentTime ||
        lastUsed + apiDuration > currentTime)
    );
  }
);



// WEBPACK FOOTER //
// ./src/route/selector.ts